class ProductPage extends HTMLElement {
  constructor() {
    super();
    this.addToCart = this.querySelector('[data-multi-add-to-cart]');
    this.addToCart?.addEventListener('click', this.addProductGroup.bind(this));
    this.productForms = this.querySelectorAll('product-form');
    this.cartCount = document.querySelector('[data-cart]');
    this.itemsSelected = this.querySelector('data-selected-count');
    this.productCount = document.querySelector('[data-product-selected-count]');
    this.stockLabels = this.querySelectorAll('.stock-message');
    this.optionButtons = this.querySelectorAll('.options__input');
    this.atcBtnText = document.querySelector('[data-add-to-cart-text]');
    this.total = document.querySelector('[data-selected-total]');
    this.init();
  }

  // formLengthCheck() {
  //   const productForms = document.querySelector('product-page').querySelectorAll('product-form');
  //   return productForms.length > 1 ? 'multiple' : 'single';
  // }

  init() {

  }

  afterCartUpdate() {
    // Get the cart contents from the Shopify Cart API
    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        // Update the cart count in the header
        this.cartCount.querySelector('.cart__count').innerHTML = data.item_count;
        this.cartCount.classList.add('has-updated');
        setTimeout(() => {
          this.cartCount.classList.remove('has-updated');
        }, 2500);
      });

    this.atcBtnText.innerHTML = (theme.strings.cartAdded);
    window.setTimeout(this.restore.bind(this), 2000);
  }

  addProductGroup(event) {
    event.preventDefault();
    const body = {
      items: [],
    };
    this.productForms.forEach((form) => {
      if (form.dataset.variantSelected !== "true") {
        return;
      }

      const productId = form.querySelector('[name="id"]').value;
      const quantity = form.querySelector('[name="quantity"]').value;
      if (productId) {
        body.items.push({
          id: productId,
          quantity: quantity,
        });
      }
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.afterCartUpdate();
      });
  };

  resetCounts() {
    if (this.productCount) {
      this.productCount.dataset.selected = "";
      this.productCount.dataset.count = 0;
      this.productCount.innerHTML = (theme.strings.groupedDefaultText);
    }
  }

  resetButton() {
    const currencySymbol = theme.moneyFormat;
    const currency_amount_regex = /\{\{.*?\}\}/g;
    this.atcBtnText.innerHTML = (theme.strings.addToCart);
    this.addToCart.setAttribute('disabled', true);
    this.total.innerHTML = currencySymbol.replace(currency_amount_regex, 0);
  }

  restore() {
    this.optionButtons.forEach((option) => {
      option.checked = false;
    });

    this.productForms.forEach((form) => {
      form.reset();
    });

    if (this.stockLabels.length > 0) {
      this.stockLabels.forEach((label) => {
        label.innerHTML = '';
      });
    }

    this.resetCounts();
    this.resetButton();
  }
}

customElements.define('product-page', ProductPage);


class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.sizeLabel = this.querySelector('.options__title-result');
    this.stockLabel = this.querySelector('.stock-message');
    this.addToCart  = this.querySelector('[data-add-to-cart]');
    this.multiAddToCart = document.querySelector('[data-multi-add-to-cart]');
    this.productJSON = JSON.parse(this.querySelector('[data-product-json]').innerHTML);
    this.stockJSON = JSON.parse(this.querySelector('[data-stock-inventory]').innerHTML);
    this.optionsWrapper = this.querySelector('.js-options');
    this.optionButtons = this.querySelectorAll('.options__input');
    this.cartCount = document.querySelector('[data-cart]');
    this.productCount = document.querySelector('[data-product-selected-count]');
    this.addToCart?.addEventListener('click', this.addSingleProduct.bind(this));
    this.atcBtnText = this.querySelector('[data-add-to-cart-text]');

    this.optionButtons.forEach((button) =>
      button.addEventListener('click', this.changeOption.bind(this))
    );
    // this.changeOption();
    this.onInit();
  }

  restore() {
    this.optionButtons?.forEach((option) => {
      option.checked = false;
    });

    this.reset();
    this.atcBtnText.innerHTML = (theme.strings.addToCart);

    if (!this.optionsWrapper.hasAttribute('data-single-variant')) {
      this.addToCart.setAttribute('disabled', true);
    }
  }

  addSingleProduct(event) {
    event.preventDefault();
    // Get the product ID from the hidden input in the <product-form> element
    // if found, add the product to the cart using the Shopify Cart  API and using fetch
    const productId = this.querySelector('[name="id"]').value;
    const personalization = this.querySelector('[name="properties[Personalization]"]')?.value;
    const body = {
      items: [
        {
          id: productId,
          quantity: 1,
          ...(personalization && {
            properties: {
              "Personalization": personalization
            }
          })
        },
      ],
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        this.afterCartUpdate();
      });
  }

  afterCartUpdate() {
    // Get the cart contents from the Shopify Cart API
    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        // Update the cart count in the header
        this.cartCount.querySelector('.cart__count').innerHTML = data.item_count;
        this.cartCount.classList.add('has-updated');
        setTimeout(() => {
          this.cartCount.classList.remove('has-updated');
        }, 2500);
      });

      this.atcBtnText.innerHTML = (theme.strings.cartAdded);
      window.setTimeout(this.restore.bind(this), 2000);
  }
  onInit() {
    // Loop through the this.optionsButtons and check if the variant is in stock
    // If not, disable the button
    this.optionButtons.forEach((button) => {
      const variantLabel = button.getAttribute('value');
      const variant = this.productJSON.variants.find((variant) => variant.title === variantLabel);
      const stock = this.stockJSON[variant.id];
      if (stock == 0) {
        button.classList.add('disabled');
        // button.setAttribute('disabled', true);
      }
    });
  }

  changeOption(event) {
    const variantLabel = event.target.getAttribute('value');
    const product = this.productJSON;
    const variant = product.variants.find((variant) => variant.title === variantLabel);
    const stock = this.stockJSON[variant.id];
    const total = document.querySelector('[data-selected-total]');
    const currencySymbol = theme.moneyFormat;

    this.dataset.variantSelected = "true";

    if (this.sizeLabel) {
      this.sizeLabel.innerHTML = variantLabel;
    }

    this.querySelector('[name="id"]').value = variant.id;

    stock < 5 ? this.stockLabel.innerHTML = `<span>Only ${stock} left in stock</span>` : this.stockLabel.innerHTML = ``;
    stock < 1 ? this.stockLabel.innerHTML = `<span>Out of stock</span>` : this.stockLabel.innerHTML = ``;

    // If the variant is in stock, enable the button
    if (stock > 0) {
      this.addToCart?.removeAttribute('disabled');
      this.multiAddToCart?.removeAttribute('disabled');
    }
    else {
      this.addToCart?.setAttribute('disabled', true);
      this.multiAddToCart?.setAttribute('disabled', true);
      const buttonText = this.atcBtnText ? this.atcBtnText : document.querySelector('[data-add-to-cart-text]');
      buttonText.innerHTML = (theme.strings.addToCart);
    }

    // Check to see if the this.productCount has a data attribute called data-selected
    // If it does, check to see if the data-selected attribute contains to the product ID
    // If it does not, increment the count by 1 and add the product ID to the data-selected attribute
    // If it does, do nothing
    const selectedProducts = this.productCount?.dataset.selected.split(',');
    if (selectedProducts && !selectedProducts.includes(String(this.productJSON.id))) {
      const selectedCount = parseInt(this.productCount.dataset.count);
      const totalNumber = parseInt((total.innerHTML.replace(/[^0-9]/g, '') * 100));
      const newTotal = (totalNumber + variant.price) / 100;
      this.productCount.dataset.count = selectedCount + 1;
      this.productCount.dataset.selected = `${this.productCount.dataset.selected},${String(this.productJSON.id)}`;
      this.productCount.innerHTML = `You have selected ${numberToWord(selectedCount + 1)} product` + (selectedCount + 1 > 1 ? 's' : '');


      //can we make this so that it checks all the selected products rather than just the current one?
      const stock = this.stockJSON[variant.id];

      if (stock > 0) {
        this.multiAddToCart?.removeAttribute('disabled');
      }

      const currency_amount_regex = /\{\{.*?\}\}/g;
      total.innerHTML = currencySymbol.replace(currency_amount_regex, newTotal);
    }

    function numberToWord(number) {
      const words = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
      return words[number - 1];
    }

  }

  reset() {
    this.dataset.variantSelected = "false";

    if (this.sizeLabel) {
      this.sizeLabel.innerHTML = (theme.strings.noSelection);
    }
  }
}

customElements.define('product-form', ProductForm);
